import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Instagram, Facebook, Send } from 'lucide-react';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-62" data-mp="316ab67m0yqyl">
      <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" data-id="element-63" data-mp="2w8ihb81tkurr" />
    </svg>;
}
export function Contact() {
  return <section id="contact" className="py-32 bg-ivory text-midnight" data-id="element-64" data-mp="3k331buzwbbop">
      <div className="max-w-7xl mx-auto px-6" data-id="element-65" data-mp="3f5tfsqfmnk65">
        <div className="text-center mb-16" data-id="element-66" data-mp="gg2os1t7l4io">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight/5 rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-67" data-mp="gh4cb5revjha">
            Get in Touch
          </div>
          <h3 className="text-5xl md:text-7xl font-display font-bold tracking-tighter" data-id="element-68" data-mp="3jwmbiohfxj3n">
            Connect{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-69" data-mp="3otctxigpwqs8">
              With Us
            </span>
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-70" data-mp="3b1gb650xvt8i">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-10 rounded-[2rem] border-2 border-midnight/5 text-center flex flex-col items-center hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-xl" data-id="element-71" data-mp="3f3jrp82gto0n">
            <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mb-8 text-midnight shadow-lg" data-id="element-72" data-mp="qcio0rqppl0t">
              <MapPin className="w-8 h-8" data-id="element-73" data-mp="udc9zfklgpr2" />
            </div>
            <h4 className="text-2xl font-display font-bold mb-4" data-id="element-74" data-mp="23bc4d69rwm0k">Location</h4>
            <p className="text-lg font-medium text-charcoal/70" data-id="element-75" data-mp="2397pxue904m1">
              Ugbowo, Benin City
              <br data-id="element-76" data-mp="1yeu1yd1x0zre" />
              Edo State, Nigeria
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-10 rounded-[2rem] border-2 border-midnight/5 text-center flex flex-col items-center hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-xl" data-id="element-77" data-mp="1ud04edn0obvg">
            <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mb-8 text-midnight shadow-lg" data-id="element-78" data-mp="35qkrcy5hsw19">
              <Phone className="w-8 h-8" data-id="element-79" data-mp="30yki2f3j8qs0" />
            </div>
            <h4 className="text-2xl font-display font-bold mb-4" data-id="element-80" data-mp="38aqreuqzk2cj">Phone</h4>
            <p className="text-lg font-medium text-charcoal/70" data-id="element-81" data-mp="38clbk6ufnqfk">
              +234 806 117 7617
              <br data-id="element-82" data-mp="3dboaranqf2fm" />
              +234 812 555 2897
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-10 rounded-[2rem] border-2 border-midnight/5 text-center flex flex-col items-center hover:-translate-y-2 transition-transform duration-300 shadow-sm hover:shadow-xl" data-id="element-83" data-mp="3i7dezrap57i9">
            <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mb-8 text-midnight shadow-lg" data-id="element-84" data-mp="duq72qqy9zau">
              <Mail className="w-8 h-8" data-id="element-85" data-mp="iukzwzuacyyj" />
            </div>
            <h4 className="text-2xl font-display font-bold mb-4" data-id="element-86" data-mp="56t058pt8utn">
              Email & Social
            </h4>
            <a href="mailto:campdavidprayerplatform@outlook.com" className="text-sm font-medium text-charcoal/70 hover:text-gold transition-colors block mb-6" data-id="element-87" data-mp="15h5upvzrlf4">
              campdavidprayerplatform@outlook.com
            </a>
            <div className="flex items-center flex-wrap justify-center gap-3" data-id="element-88" data-mp="9zm59xp6y569">
              <a href="mailto:campdavidprayerplatform@outlook.com" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Email" data-id="element-89" data-mp="3iduq2jlh1rnv">
                <Mail className="w-5 h-5" data-id="element-90" data-mp="3naup4ajwlu5h" />
              </a>
              <a href="https://www.instagram.com/campdavidprayerplatform?igsh=czk3cm92d3k2bnB2&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Instagram" data-id="element-91" data-mp="17kruws1cyqvm">
                <Instagram className="w-5 h-5" data-id="element-92" data-mp="2bkpy1aiyjhik" />
              </a>
              <a href="https://www.facebook.com/share/18Uxv6Kc87/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Facebook" data-id="element-93" data-mp="2ghgdbvmxu92x">
                <Facebook className="w-5 h-5" data-id="element-94" data-mp="2zgkginrst8mo" />
              </a>
              <a href="https://www.tiktok.com/@campdavidnation?_r=1&_t=ZS-96iUSUYiIqr" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="TikTok" data-id="element-95" data-mp="2zera99l3kqf7">
                <TikTokIcon className="w-5 h-5" data-id="element-96" data-mp="mts83mx3tl9" />
              </a>
              <a href="https://t.me/+clyrH4FDK9JlNmU8" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-midnight/5 flex items-center justify-center text-midnight hover:bg-midnight hover:text-ivory transition-colors" aria-label="Telegram" data-id="element-97" data-mp="3rtwdyfjzl7o3">
                <Send className="w-5 h-5" data-id="element-98" data-mp="3946lhz3p4xzc" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}